<template>
  <div v-if="pageConfig">
    <XTable :inConfig="pageConfig" :defaultConfig="pageConfig.defaultConfig" :showTitle="showTitle" :select="select" @event="event_func" @select="select" ref="table" />
  </div>
</template>

<script>
  import {getPageInfo} from '@/api/api'
  export default {
    props: {
      name: {
        type: String,
        default: ''
      },
      defaultConfig: {
        type: Object,
        default: () => {}
      },
      showTitle: {
        type: Boolean,
        default: true
      },
      select: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        pageConfig: null
      }
    },

    created() {
      getPageInfo({key: this.name}).then(res => {
        let data = res.data
        if (this.defaultConfig) {
          data.defaultConfig = this.defaultConfig
        }
        this.pageConfig = data
      })
    },
    methods: {
      select(e) {
        this.$emit('select', e)
      },
      event_func(e) {
        this.$emit('event', e)
      },
      Search() {
        this.$refs.table.Search()
      }
    }
  }
</script>

<style lang="scss" scoped></style>
